import { ecsClientSettings } from '../initializeAnalytics';
import { AriaDatapoint } from '../datapoints/AriaDatapoint';
import { CustomDataMap } from 'owa-analytics-types';
import { UserActionEvent, EventMappings } from '../types/EcsTelemetrySettingTypes';
import { ecsWebClient } from './ecsWebClient';

// A legacy event to remap as unified must match ECS Legacy EventMappings,
// and have an enabled entry in the the UserActionEvent catalog.
export function matchLegacyMappingsAndCatalog(datapoint: AriaDatapoint): UserActionEvent[] {
    const legacyMappings = matchLegacyEventMappings(datapoint.properties);
    return legacyMappings && legacyMappings?.length > 0
        ? matchUserActionCatalog(legacyMappings[0].actionName)
        : [];
}

// Matches an event name to an enabled entry in the ECS UserActionEvent catalog.
export function matchUserActionCatalog(datapointEventName: string): UserActionEvent[] {
    return (
        ecsClientSettings?.userActionEventCatalog?.userActionEvents?.filter(
            x => x.actionName == datapointEventName && x.enabled
        ) ?? []
    );
}

// Matches an event through filters defined in the ECS Legacy EventMappings.
function matchLegacyEventMappings(properties: CustomDataMap): EventMappings[] | undefined {
    // Query the topFilter definition
    const mappings = ecsClientSettings?.legacyEventMappings?.eventMappings?.filter(
        x =>
            x.clients.indexOf(ecsWebClient) > -1 &&
            x.topFilter?.field &&
            x.topFilter?.values &&
            x.topFilter.values.indexOf(<string>properties[<string>x.topFilter.field]) > -1
    );
    if (mappings?.length > 0) {
        // Query the subFilter definition
        if (mappings[0].subFilter?.field) {
            if (
                !(
                    mappings[0].subFilter.values.indexOf(
                        <string>properties[<string>mappings[0].subFilter.field]
                    ) > -1
                )
            ) {
                return undefined;
            }
        }
        // Query the Key/Value filter definition
        if (mappings[0].kvFilter?.field) {
            const targetField = JSON.parse(<string>properties[mappings[0].kvFilter.field]);
            if (mappings[0].kvFilter.keyValue !== targetField[mappings[0].kvFilter.keyName]) {
                return undefined;
            }
        }
    }

    return mappings;
}
